import { render, staticRenderFns } from "./AtividadesNovoTrabalho.vue?vue&type=template&id=58f243ed"
import script from "./AtividadesNovoTrabalho.vue?vue&type=script&lang=js"
export * from "./AtividadesNovoTrabalho.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports